export default __webpack_public_path__ + "static/media/battery.000c905d.svg";